var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('STable',{ref:"tableref",attrs:{"url":_vm.url,"columns":_vm.columns,"handles":_vm.handles,"query":_vm.query,"selection":false,"toolbar":_vm.toolbar,"labelWidth":"120px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa4e0b94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BMS/firmManagement/findProject.vue
// module id = null
// module chunks = 